/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppInactivityDataSchema = z.object({
	scheduledDeactivationAt: z.string().nullable(),
})

export type WhatsAppInactivityDataSchema = z.infer<typeof whatsAppInactivityDataSchema>
